import React, { useState } from 'react';
import './QueryMetadataHeader.css';

// Nombres amigables para las operaciones
const OPERATION_NAMES = {
  'MECANIZAR': 'Mecanizar',
  'TALADRO': 'Taladro',
  'CHAVETERO': 'Chavetero',
  'TALLADO': 'Tallado',
  'MECANIZAR_2FASE': 'Mecanizar 2ª fase',
  'RECTIFICAR_DIAMETROS': 'Rect. diámetros',
  'RECTIFICAR_FLANCOS': 'Rect. flancos',
  'TALLAR_ESTRIAS': 'Tallar estrías',
  'RECTIFICAR_ESTRIAS': 'Rect. estrías'
};

const QueryMetadataHeader = ({ metadata, queryAnalysis, filename }) => {
  const [expanded, setExpanded] = useState(false);

  const analysis = queryAnalysis || {};
  const operations = analysis.OperacionesMecanizado || {};
  const tipoPieza = analysis.TipoPieza || metadata?.part_type || 'N/A';

  // Verificar si una operación tiene datos significativos
  const hasOperationData = (opKey) => {
    const opData = operations[opKey];
    if (!opData) return false;
    return Object.values(opData).some(v =>
      v !== null && v !== undefined &&
      (Array.isArray(v) ? v.length > 0 : true)
    );
  };

  const activeOps = Object.keys(OPERATION_NAMES).filter(hasOperationData);

  if (!analysis.TipoPieza && (!metadata || Object.keys(metadata).length === 0)) {
    return null;
  }

  return (
    <div className="query-metadata-header">
      <div className="header-title" onClick={() => setExpanded(!expanded)}>
        <h3>Tu pieza analizada</h3>
        <div className="header-summary">
          <span className="tipo-badge">{tipoPieza}</span>
          <span className="ops-count">{activeOps.length} operaciones</span>
          {filename && <span className="filename">{filename}</span>}
        </div>
        <span className="expand-icon">{expanded ? '▲' : '▼'}</span>
      </div>

      {expanded && (
        <div className="operations-list">
          {activeOps.map(opKey => (
            <span key={opKey} className="op-tag">{OPERATION_NAMES[opKey]}</span>
          ))}
        </div>
      )}
    </div>
  );
};

export default QueryMetadataHeader;
